import { render, staticRenderFns } from "./TeacherContent.vue?vue&type=template&id=b77112a6&scoped=true&"
import script from "./TeacherContent.vue?vue&type=script&lang=js&"
export * from "./TeacherContent.vue?vue&type=script&lang=js&"
import style0 from "./TeacherContent.vue?vue&type=style&index=0&id=b77112a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77112a6",
  null
  
)

export default component.exports